import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import { processRepositoryItem } from ".";
import ConfigProperty from "./ConfigProperty";
var SKU = (_dec = observable.ref, _dec2 = observable.shallow, (_class = /*#__PURE__*/function () {
  function SKU(rawMenuBean, parent) {
    _classCallCheck(this, SKU);

    _initializerDefineProperty(this, "_data", _descriptor, this);

    _defineProperty(this, "_parent", void 0);

    _initializerDefineProperty(this, "_configProperties", _descriptor2, this);

    _initializerDefineProperty(this, "_selected", _descriptor3, this);

    makeObservable(this);
    this._parent = parent;
    this.setRawMenuBean(rawMenuBean);
  }

  _createClass(SKU, [{
    key: "processConfigPropertyEntries",
    value: function processConfigPropertyEntries() {
      var _this = this;

      runInAction(function () {
        var _menuSkuBeanItem$prop;

        var menuSkuBeanItem = _this._data.menuSkuBean;
        _this._configProperties = (_menuSkuBeanItem$prop = menuSkuBeanItem.propertyBeans) === null || _menuSkuBeanItem$prop === void 0 ? void 0 : _menuSkuBeanItem$prop.reduce(function (res, rawPropertyBean) {
          var configProp = new ConfigProperty(rawPropertyBean, _this);

          if (!configProp.isEmpty) {
            res.push(configProp);
          }

          return res;
        }, []);
      });
    }
  }, {
    key: "setRawMenuBean",
    value: function setRawMenuBean(rawMenuBean) {
      var _this2 = this;

      runInAction(function () {
        _this2._data = rawMenuBean;
      });
      this.processConfigPropertyEntries();
    }
  }, {
    key: "clearTree",
    value: function clearTree() {
      var _this$_configProperti;

      this.selected = false;
      (_this$_configProperti = this._configProperties) === null || _this$_configProperti === void 0 ? void 0 : _this$_configProperti.forEach(function (property) {
        property.clearTree();
      });
    }
  }, {
    key: "makeRecursiveDefaultSelections",
    value: function makeRecursiveDefaultSelections() {
      var _this$_configProperti2;

      this._selected = true;
      (_this$_configProperti2 = this._configProperties) === null || _this$_configProperti2 === void 0 ? void 0 : _this$_configProperti2.forEach(function (property) {
        property.makeRecursiveDefaultSelections();
      });
    }
  }, {
    key: "findConfigOptionById",
    value: function findConfigOptionById(optionId) {
      var opt = null;

      if (this.optionId === optionId) {
        return opt;
      } else {
        var _this$_configProperti3;

        (_this$_configProperti3 = this._configProperties) === null || _this$_configProperti3 === void 0 ? void 0 : _this$_configProperti3.forEach(function (configProp) {
          if (!opt) {
            opt = configProp.findConfigOptionById(optionId);
          }
        });
        return opt;
      }
    }
  }, {
    key: "findSelectionTreeForOptionBySelectedId",
    value: function findSelectionTreeForOptionBySelectedId(selectedId) {
      var _this3 = this;

      var nodes = [];

      if (this.optionId === selectedId) {
        nodes.push(this);
      } else {
        var _this$_configProperti4;

        (_this$_configProperti4 = this._configProperties) === null || _this$_configProperti4 === void 0 ? void 0 : _this$_configProperti4.forEach(function (configProp) {
          var propNodes = configProp.findSelectionTreeForOptionBySelectedId(selectedId);

          if (propNodes.length > 0) {
            nodes.push(_this3);
            nodes.push.apply(nodes, _toConsumableArray(propNodes));
          }
        });
      }

      return nodes;
    }
  }, {
    key: "findConfigOptionBySelectedId",
    value: function findConfigOptionBySelectedId(selectedId) {
      var opt = null;

      if (this.selectedId === selectedId) {
        return opt;
      } else {
        var _this$_configProperti5;

        (_this$_configProperti5 = this._configProperties) === null || _this$_configProperti5 === void 0 ? void 0 : _this$_configProperti5.forEach(function (configProp) {
          if (!opt) {
            opt = configProp.findConfigOptionBySelectedId(selectedId);
          }
        });
        return opt;
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._configProperties;
    }
  }, {
    key: "depth",
    get: function get() {
      return 0;
    }
  }, {
    key: "floor",
    get: function get() {
      if (this._configProperties && this._configProperties.length > 0) {
        var maxFloor = 0;

        this._configProperties.forEach(function (opt) {
          if (opt.floor > maxFloor) {
            maxFloor = opt.floor;
          }
        });

        return maxFloor + 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "pretty",
    get: function get() {
      var _this$_configProperti6;

      return {
        isInValid: this.isInValid,
        selected: this.selected,
        optionId: this.optionId,
        optionName: this.optionName,
        renderingOption: this.renderingOption,
        isMultiSelect: this.isMultiSelect,
        isMandatory: this.isMandatory,
        selectedId: this.selectedId,
        displayName: this.displayName,
        price: this.price,
        description: this.description,
        depth: this.depth,
        floor: this.floor,
        properties: (_this$_configProperti6 = this._configProperties) === null || _this$_configProperti6 === void 0 ? void 0 : _this$_configProperti6.map(function (prop) {
          return prop.pretty;
        })
      };
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selected;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        if (val) {
          _this4._parent.clearTree([_this4.optionId]);

          _this4.makeRecursiveDefaultSelections();
        } else {
          _this4._selected = val;
        }
      });
    }
  }, {
    key: "isInValid",
    get: function get() {
      if (this.selected) {
        var _this$_configProperti7;

        var atleastOneConfigPropertyIsInvalid = false;
        (_this$_configProperti7 = this._configProperties) === null || _this$_configProperti7 === void 0 ? void 0 : _this$_configProperti7.forEach(function (property) {
          if (property.isInValid) {
            atleastOneConfigPropertyIsInvalid = true;
          }
        });
        return atleastOneConfigPropertyIsInvalid;
      } else {
        return false;
      }
    }
  }, {
    key: "repoItem",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return processRepositoryItem(menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.repositoryItem);
    }
  }, {
    key: "optionId",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.id;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this.repoItem.defaultDisplayName;
    }
  }, {
    key: "heading",
    get: function get() {
      return this.repoItem.defaultDisplayName;
    }
  }, {
    key: "optionName",
    get: function get() {
      return this.repoItem.defaultDescription;
    }
  }, {
    key: "renderingOption",
    get: function get() {
      return this.repoItem.renderingOption;
    }
  }, {
    key: "isMultiSelect",
    get: function get() {
      var _this$_configProperti8;

      return ((_this$_configProperti8 = this._configProperties) === null || _this$_configProperti8 === void 0 ? void 0 : _this$_configProperti8.length) > 0;
    }
  }, {
    key: "isMandatory",
    get: function get() {
      return this._parent.isComplex;
    }
  }, {
    key: "isCollapsible",
    get: function get() {
      return this.repoItem.isCollapsible;
    }
  }, {
    key: "price",
    get: function get() {
      var _this$_parent$skuPric, _this$_parent$price$;

      return this.repoItem.listPrice || ((_this$_parent$skuPric = this._parent.skuPriceMap[this.optionId]) === null || _this$_parent$skuPric === void 0 ? void 0 : _this$_parent$skuPric.price) || ((_this$_parent$price$ = this._parent.price[0]) === null || _this$_parent$price$ === void 0 ? void 0 : _this$_parent$price$.price);
    }
  }, {
    key: "description",
    get: function get() {
      return this.repoItem.description;
    }
  }, {
    key: "selectedId",
    get: function get() {
      var _this$_data;

      return ((_this$_data = this._data) === null || _this$_data === void 0 ? void 0 : _this$_data.selectedId) || this.optionId;
    }
  }, {
    key: "unitOfMeasure",
    get: function get() {
      return this.repoItem.uom;
    }
  }, {
    key: "winePairingIds",
    get: function get() {
      return this.repoItem.winePairingIds;
    }
  }, {
    key: "greyOut",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.greyOut;
    }
  }, {
    key: "isAlcohol",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.alcohol;
    }
  }, {
    key: "alcoholSubClassification",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.alcoholSubClassification;
    }
  }, {
    key: "isFoodItem",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.foodItem;
    }
  }, {
    key: "portionSize",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.portionSize;
    }
  }, {
    key: "preparationTime",
    get: function get() {
      return this.repoItem.preparationTime;
    }
  }, {
    key: "maxCookTime",
    get: function get() {
      return this.repoItem.maxCookTime;
    }
  }, {
    key: "selectedIds",
    get: function get() {
      return this.selectedConfigOptions.map(function (opt) {
        return opt.selectedId;
      });
    }
  }, {
    key: "selectedConfigOptions",
    get: function get() {
      var opts = [];

      if (this.selected) {
        var _this$_configProperti9;

        (_this$_configProperti9 = this._configProperties) === null || _this$_configProperti9 === void 0 ? void 0 : _this$_configProperti9.forEach(function (configProp) {
          var selectedConfigOptions = configProp.selectedConfigOptions;
          opts = opts.concat(selectedConfigOptions);
        });
      }

      return opts;
    }
  }, {
    key: "selectedConfigOptionsPrice",
    get: function get() {
      return this.selectedConfigOptions.reduce(function (total, configOpt) {
        return configOpt.price && configOpt.price > 0 ? total + configOpt.price : total;
      }, 0);
    }
  }, {
    key: "itemTotalPrice",
    get: function get() {
      return this.price + this.selectedConfigOptionsPrice;
    }
  }, {
    key: "isBeverageItem",
    get: function get() {
      var menuSkuBeanItem = this._data.menuSkuBean;
      return menuSkuBeanItem === null || menuSkuBeanItem === void 0 ? void 0 : menuSkuBeanItem.bevarageItem;
    }
  }]);

  return SKU;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_configProperties", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_selected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "options", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "options"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "depth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "depth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "floor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "floor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pretty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pretty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makeRecursiveDefaultSelections", [action], Object.getOwnPropertyDescriptor(_class.prototype, "makeRecursiveDefaultSelections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "repoItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "repoItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "heading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "heading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderingOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "renderingOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMultiSelect", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMultiSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMandatory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMandatory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCollapsible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCollapsible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "price", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "price"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unitOfMeasure", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unitOfMeasure"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "winePairingIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "winePairingIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "greyOut", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "greyOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAlcohol", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAlcohol"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alcoholSubClassification", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alcoholSubClassification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFoodItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFoodItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "portionSize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "portionSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preparationTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preparationTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxCookTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxCookTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedConfigOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedConfigOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedConfigOptionsPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedConfigOptionsPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemTotalPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemTotalPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBeverageItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBeverageItem"), _class.prototype)), _class));
export { SKU as default };